<template>
    <div>
        <workspace-header :providedSecondaryTitle="breadcrumbTitle" :isTpg="isTpg">
        </workspace-header>

        <payment-method-modal v-if="showPaymentModal" @close="showPaymentModal = false" @newPaymentMethodCreated="newPaymentMethodCreated" ref="modalPaymentMethod" :locationId="id" shouldCenter="1" :isTpg="isTpg" style="z-index: 1000;" close-on-backdrop></payment-method-modal>

        <add-address-modal v-if="showAddressModal" @close="showAddressModal = false" @newPaymentMethodCreated="newPaymentMethodCreated" ref="modalAddAddresses" @addAddress="addAddress" :locationId="id" :accountId="account_id" :userInfo="userInfo" :categoryId="addressModalCategoryId"
            :isTpg="isTpg" close-on-backdrop></add-address-modal>

        <add-contact-modal v-if="showContactModal" @close="showContactModal = false" @newPaymentMethodCreated="newPaymentMethodCreated" ref="modalContacts" @addContact="addContact" :locationId="id" :accountId="account_id" :userInfo="userInfo" :categoryId="contactModalCategoryId"
            :isTpg="isTpg" close-on-backdrop></add-contact-modal>

        <!-- <manage-contacts-modal ref="modalManageContacts" @removeContactFromObject="removeContactFromObject" :accountContacts="accountContacts" :userInfo="userInfo" :accountId="account_id" :locationId="id" :categoryId="contactModalCategoryId" :isTpg="isTpg"></manage-contacts-modal>
                <manage-addresses-modal ref="modalManageAddresses" @removeAddressFromObject="removeAddressFromObject" :accountAddresses="accountAddresses" :userInfo="userInfo" :accountId="account_id" :locationId="id" :categoryId="addressModalCategoryId" :isTpg="isTpg"></manage-addresses-modal> -->
        <LocationZone v-if="showZoneModal" @close="showZoneModal = false, selectedLocationZoneId = null" ref="locationZoneModal" :id="selectedLocationZoneId" @zoneSaved="zoneSaved" @zoneCreated="zoneCreated" :locationId="id" :userInfo="userInfo" :locationDocuments="documents"
            :isTpg="isTpg"></LocationZone>

        <div class="location-form-content" :class="{isTpg:isTpg}" style="height:auto" id="formTopping">
            <reload-page v-if="showReload" :showReloadMessage="showReloadMessage" style="margin-top:50px;" id="reload-component"></reload-page>

            <div class="alert alert-danger" role="alert" v-html="errorString" v-if="errorString" style="width:80%;margin:0 auto;margin-bottom: 20px;">

            </div>

            <div v-if="locationStatus == 12 || locationStatus == 13" class="demo-blurb">
                <div v-if="isTpg">
                    <div class="demo_header">
                        Demo Signup
                    </div>
                    <div>
                        In order to proceed with your demo, we need the following from you:
                        <ul>
                            <li>The form below, filled out and submitted</li>
                            <li>A $200 deposit</li>
                            <li>Creative direction to help us create your playlist</li>
                        </ul>
                        Once we receive your creative direction, we will send you music samples to ensure we’re headed in the right direction in discovering your Sonic Identity<small><sup>&trade;</sup></small>. Once you have approved the samples, we will
                        design your full playlist. Though it’s for a 2-week demo period, this is not an abbreviated version of your playlist—it’s a full representation, as we want you to have a true understanding of the end product and how we work with our
                        clients.
                        <br> <br> Everything at TPG is developed and done in-house, from onboarding to customer service to music discovery to content management to royalty reporting—and, of course, the playlists themselves. We will customize and daypart your
                        full playlist based on our discussions with you. Our team builds each playlist in multiple layers, picking the songs that work best together for specific times of the day.
                        <br> <br> We will ship the player to you within a week of your samples being approved, and it should arrive 2-5 days after that. If you need the player within 2 weeks, please note that there is a non-refundable $50 rush charge and
                        an additional non-refundable $25 shipping charge. Please check the “Rush” box below if you need this option.
                    </div>

                    <div class="demo_header">
                        Demo Feedback
                    </div>
                    <div>
                        We understand the challenges that exist in not only building an authentic atmosphere but also sustaining it, so that your spaces remain engaging and exciting at all times. At TPG, we design playlists that fit seamlessly with your unique aesthetic and
                        personality. When it comes to music, we don’t believe in one-size-fits-all algorithms—there is nothing generic about our services.
                        <br> <br> During the 2-week demo period, it is crucial that we get feedback from you on your playlist. Vote on as many tracks as possible (“Love it” or “Leave it”), and don’t hesitate to email or call us to discuss larger changes.
                        The best way for TPG to truly understand the nuances of how the playlist works in your space and with your customers is through communication. The more we know about your Sonic Identity<small><sup>&trade;</sup></small>, the more we
                        can fine-tune, and the better your playlist will fit your space and its changing pace throughout the day.
                    </div>

                    <div class="demo_header">
                        Beyond the Demo
                    </div>
                    <div>
                        If you’re loving your new music and want to move forward with TPG after the 2-week demo period is over, we will invoice you at that time. You will be charged via the credit card/ACH supplied in the demo signup form for the Startup (less your $200 deposit)
                        and the first month of service; you will see this charge within 2 weeks of the end of the demo period. Moving forward, we will continue to bill your monthly service on this credit card/ACH.
                    </div>

                    <div class="demo_header">
                        Returning the Demo
                    </div>
                    <div>
                        If you decide TPG is not the right fit for your business after the 2-week demo period, you will have 5 business days to supply us with a tracking number for the return of the player. This will be sent back to us at your expense via FedEx or UPS (insured
                        for $400), and we will send more detailed instructions for the return. Please make sure to return the player in its original packaging, with all the cables and in the same condition we sent it to you. Once the equipment is returned
                        and inspected, we will refund your deposit less any rush and/or shipping charges.
                    </div>

                </div>
                <div v-else class="demo-blurb">
                    <div class="demo_header">
                        Demo Signup: Let’s Get Started
                    </div>

                    <div>
                        To get rolling on the demo, we need a couple of things from you:
                        <ul>
                            <li>We need the demo form filled out (including a $200 deposit).</li>
                            <li>We need creative direction from you to help us create your playlist.</li>
                        </ul>
                        Once we have creative direction, we will send you samples to ensure we're all on the same page, and then we will put together the full playlist. This playlist is not an abbreviated version of your music; we will create the full startup list. By taking
                        the time to build out your entire playlist, you get a real picture of the end product. It will be dayparted and customized based on our discussions with you before and during the demo period.
                        <br><br> Once the samples are approved:
                        <ul>
                            <li>We ship the player to you within a week.</li>
                            <li>It should arrive within 2-5 days.</li>
                            <li>If you need the player quicker than two weeks after you fill out this form, there is a non-refundable $75 rush and shipping charge. Please check the "Rush" box below if you need this option.</li>
                        </ul>
                    </div>

                    <div class="demo_header">
                        Your Demo Begins
                    </div>
                    <div>
                        At Gray V, we create unique soundtracks that help set the tone for your brand. We work with you to enhance your customers' experience, designing playlists that fit seamlessly with your aesthetic and personality. There is nothing generic about our service.
                        Ultimately, we understand the challenges that exist, not only in building an authentic atmosphere but sustaining it, so that your spaces remain engaging and exciting all of the time.
                        <br><br> During the two-week demo period, we must get feedback from you. Vote as much as you possibly can, and don't hesitate to e-mail or call us to discuss more extensive changes. Music is subjective, and it takes a bit of back and
                        forth to get a real understanding of some of the nuances surrounding the playlist and how it's working in the space. The more we know, the better your playlist will fit your space and the pace of the day.
                    </div>

                    <div class="demo_header">
                        Beyond the Demo
                    </div>
                    <div>
                        If you're loving your new music and want to move forward with Gray V once the demo period is over, we will invoice you at that time. Once approved, the credit card/ACH supplied on this demo signup form is processed for the proposal amount (less the demo
                        fee). Moving forward, we will continue to bill your monthly service on this same credit card/ACH.
                    </div>

                    <div class="demo_header" id="setup_guide">
                        Returning the Demo
                    </div>
                    <div>
                        If you decide Gray V is not the right fit for your business after the two-week demo period, you will have five business days to supply us with a tracking number for the player's return. The complete package (all cables, player, and SD card) in its original
                        box needs to be sent back to us at your expense via FedEx or UPS (insured for $400); we will send instructions for the return. Please ensure it comes home in the same condition it was when we sent it to you. Once our equipment is returned
                        and inspected, we will refund your deposit (less any rush charges).
                    </div>
                </div>
            </div>
            <div v-if="locationStatus == 14" class="demo-blurb">
                <div v-if="isTpg">
                    <div class="demo_header">
                        Let's Get Started
                    </div>
                    Thank you for reaching out to TPG. We look forward to talking to you more in-depth about your playlist and Sonic Identity<small><sup>&trade;</sup></small>. As a boutique agency, we put people first—we believe the client experience should
                    never come second to the technology we rely on. Making sure you have everything you need to create and maintain the right atmosphere, from troubleshooting to the perfect playlist, is our top priority.
                    <br><br> The TPG team has spent the two past decades developing tools to help us manage your playlists in a streamlined way, adapting effortlessly to the space and time of day. Our services include access to our Client Web tools, Custom
                    Mixes and anything else you need to get your music just right. And we are always here for you: It is our goal to solve issues right away, or within a few hours, whenever possible. In addition, TPG handles all licensing fees associated
                    with our business and yours, including ASCAP, BMI, SESAC, SOCAN and GMR.
                    <br><br> Below you'll find our proposal and service agreement. Please fill out the form and let us know if you have any questions. Once you submit the form, we’ll discuss the music with you and send you samples for approval. Once the samples
                    are signed off on, we’ll start designing your full custom playlist.
                </div>
                <div v-else>
                    <div class="demo_header">
                        Let's Get Started
                    </div>
                    <div class="intro-blurb">
                        Thank you for reaching out to us, we look forward to talking to you more in-depth about your playlists. We believe the client experience should never come second to the technology we rely on. As a boutique agency, people come first: making sure you have
                        everything you need is important to us, from troubleshooting to perfect playlists. It’s all important.
                        <br><br> We understand the role of a great playlist, it needs to create and sustain the right atmosphere, that’s why we are always here. It is our goal to solve issues right away or within a few hours whenever possible.
                        <br><br> We have spent the two past decades developing tools to help us manage your playlists in a streamlined way, adapting effortlessly to the space and time of day. You’ll have access to our Client Web tools, Custom Mixes, and anything
                        else you need to get your music just right.
                        <br><br> Gray V also handles all of the licensing fees associated with our business and yours, including ASCAP, BMI, SESAC, SOCAN, and GMR.
                        <br><br> Below you'll find our proposal and service agreement, fill out the form below and let us know if you have any questions. Once you submit the form, we’ll discuss the music with you, and get you some samples for approval. Once
                        they’re signed off on, we’ll be on our way to getting you some new music. We look forward to working on your project.
                    </div>
                </div>
            </div>
            <div v-if="locationStatus == 15" class="demo-blurb">
                <div v-if="isTpg">
                    <div class="demo_header">
                        New Location
                    </div>
                    We’re excited to work with you again! As you know by now, TPG puts people first—we believe the client experience should never come second to the technology we rely on. Making sure you have everything you need to create and maintain the right atmosphere,
                    from troubleshooting to the perfect playlist, is our top priority.
                    <br><br> The TPG team has spent the two past decades developing tools to help us manage your playlists in a streamlined way, adapting effortlessly to the space and time of day. Our services include access to our Client Web tools, Custom
                    Mixes and anything else you need to get your music just right. And we are always here for you: It is our goal to solve issues right away, or within a few hours, whenever possible. In addition, TPG handles all licensing fees associated
                    with our business and yours, including ASCAP, BMI, SESAC, SOCAN and GMR.
                    <br><br> Below you'll find our proposal and service agreement. Please fill out the form and let us know if you have any questions. Once you submit the form and we receive your information, we can ship your player to you.
                </div>
                <div v-else>
                    <div class="demo_header">
                        New Location
                    </div>
                    We’re excited to work with you on another project. As you know from working with us, people come first: making sure you have everything you need is important to us, from troubleshooting to perfect playlists. It’s all important, feel free to reach out
                    to us if you have any questions about this form or anything else.
                    <br><br> Fill out the below information, once you submit the completed form and we have music direction, we will get your new music out to you.
                    <br><br> We have spent the two past decades developing tools to help us manage your playlists in a streamlined way, adapting effortlessly to the space and time of day. You’ll have access to our Client Web tools, Custom Mixes, and anything
                    else you need to get your music just right.
                    <br><br> Gray V also handles all of the licensing fees associated with our business and yours, including ASCAP, BMI, SESAC, SOCAN, and GMR.
                </div>
            </div>

            <form method="post" enctype="multipart/form-data" @submit.prevent="submitForm" class="form-check onboarding-container" :class="{isTpg:isTpg}" name="onboarding_form" style="height:100%" id="top-o-form">

                <div class="" style="width:97%;">
                    <fieldset :class="{isTpg:isTpg}">
                        <div class="section-header">
                            Location Information
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{inlineError:v$.name.$error,isTpg:isTpg}">
                                Location Name: *
                            </div>
                            <div class="col-lg-8">
                                <input type="text" name="Location Name" id="location_name" v-model="name" placeholder="e.g. Main Street, Downtown">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Store Number:
                            </div>
                            <div class="col-lg-8">
                                <input type="text" name="Store Number" id="store_number" v-model="store_number">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Business Type:
                            </div>
                            <div class="col-lg-8">
                                <vue-select close-on-select name="Business Type" v-model="business_type" :options="categories" label-by="name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;"></vue-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                Already open:
                            </div>
                            <div class="col-lg-8">
                                <input type="checkbox" name="already_open" id="already_open" class="checkbox" v-model="already_open" style="margin-top:10px;">
                            </div>
                        </div>

                        <div class="row" v-if="!already_open" style="padding-top:9px;" id="service_start_date">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Service Start Date:
                            </div>
                            <div class="col-lg-8 date-picker">
                                <datepicker :lowerLimit="enableDdates" name="Startup Date" placeholder="MM/DD/YYYY" class="datepicker" inputFormat="MM/dd/yyyy" v-model="startup_date" :use-utc="false" style="border:0px solid #ccc;"></datepicker>
                            </div>
                        </div>

                        <div class="dashed-line"></div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Location Address:
                            </div>
                            <div class="col-lg-7">
                                <vue-select close-on-select :placeholder="physical_address.display_name" v-model="physical_address" :options="accountAddresses" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setPhysicalAddress" v-if="accountAddresses && accountAddresses.length > 0">
                                </vue-select>

                                <div class="add-address-container" v-else @click="popAddressesModal('add',PHYSICAL_ADDRESS_CATEGORY_ID)">Add an address to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountAddresses && accountAddresses.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popAddressesModal('manage',PHYSICAL_ADDRESS_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popAddressesModal('add',PHYSICAL_ADDRESS_CATEGORY_ID)">+ Add Address</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popAddressesModal('add',PHYSICAL_ADDRESS_CATEGORY_ID)">

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Location Manager:
                            </div>
                            <div class="col-lg-7">
                                <vue-select v-model="general_manager" toggle="true" openDirection="bottom" close-on-select :options="accountContacts" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setGMContact" :placeholder="general_manager.display_name" :key="accountContacts.id" v-if="accountContacts && accountContacts.length > 0">

                                </vue-select>
                                <div class="add-contact-container" v-else @click="popContactsModal('add',GM_CONTACT_CATEGORY_ID)">Add a contact to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountContacts && accountContacts.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popContactsModal('manage',GM_CONTACT_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popContactsModal('add',GM_CONTACT_CATEGORY_ID)">+ Add Contact</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popContactsModal('add',GM_CONTACT_CATEGORY_ID)">

                            </div>
                        </div>

                    </fieldset>

                    <fieldset :class="{isTpg:isTpg}">
                        <div class="section-header">
                            Shipping Information
                        </div>
                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Shipping Address:
                            </div>
                            <div class="col-lg-7">
                                <vue-select close-on-select v-model="shipping_address" :placeholder="shipping_address.display_name" :options="accountAddresses" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setShippingAddress" v-if="accountAddresses && accountAddresses.length > 0">
                                </vue-select>

                                <div class="add-address-container" v-else @click="popAddressesModal('add',SHIPPING_ADDRESS_CATEGORY_ID)">Add an address to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountAddresses && accountAddresses.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popAddressesModal('manage',SHIPPING_ADDRESS_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popAddressesModal('add',SHIPPING_ADDRESS_CATEGORY_ID)">+ Add Address</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popAddressesModal('add',SHIPPING_ADDRESS_CATEGORY_ID)">

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Shipping Contact:
                            </div>
                            <div class="col-lg-7">
                                <vue-select close-on-select v-model="shipping_contact" :placeholder="shipping_contact.display_name" :options="accountContacts" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setShippingContact" v-if="accountContacts && accountContacts.length > 0">
                                </vue-select>

                                <div class="add-contact-container" v-else @click="popContactsModal('add',SHIPPING_CONTACT_CATEGORY_ID)">Add a contact to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountContacts && accountContacts.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popContactsModal('manage',SHIPPING_CONTACT_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popContactsModal('add',SHIPPING_CONTACT_CATEGORY_ID)">+ Add Contact</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popContactsModal('add',SHIPPING_CONTACT_CATEGORY_ID)">

                            </div>
                        </div>

                    </fieldset>

                    <fieldset v-if="shouldShowPaymentMethod || shouldShowPaymentMethod === true" :class="{isTpg:isTpg}">
                        <div class="section-header">
                            Billing Information
                        </div>
                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Billing Address:
                            </div>
                            <div class="col-lg-7">
                                <vue-select close-on-select v-model="billing_address" :placeholder="billing_address.display_name" :options="accountAddresses" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setBillingAddress" v-if="accountAddresses && accountAddresses.length > 0">
                                </vue-select>

                                <div class="add-address-container" v-else @click="popAddressesModal('add',BILLING_ADDRESS_CATEGORY_ID)">Add an address to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountAddresses && accountAddresses.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popAddressesModal('manage',BILLING_ADDRESS_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popAddressesModal('add',BILLING_ADDRESS_CATEGORY_ID)">+ Add Address</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popAddressesModal('add',BILLING_ADDRESS_CATEGORY_ID)">

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Billing Contact:
                            </div>
                            <div class="col-lg-7">
                                <vue-select close-on-select :placeholder="billing_contact.display_name" v-model="billing_contact" :options="accountContacts" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setBillingContact" v-if="accountContacts && accountContacts.length > 0">
                                </vue-select>

                                <div class="add-contact-container" v-else @click="popContactsModal('add',BILLING_CONTACT_CATEGORY_ID)">Add a contact to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountContacts && accountContacts.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popContactsModal('manage',BILLING_CONTACT_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popContactsModal('add',BILLING_CONTACT_CATEGORY_ID)">+ Add Contact</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popContactsModal('add',BILLING_CONTACT_CATEGORY_ID)">

                            </div>
                        </div>

                        <div class="dashed-line" id="payment_method_row"></div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Payment Method:
                            </div>
                            <div class="col-lg-8">
                                <div v-if="payment_method">
                                    {{ payment_method.label }} &nbsp;&nbsp;&nbsp;[
                                    <span class="update-payment-link" @click="popPaymentsModal()">Change Payment Method</span>]
                                </div>
                                <div v-else>
                                    <div class="add-contact-container" @click="popPaymentsModal()" :class="{isTpg:isTpg}">Add payment method for this location</div>
                                </div>
                                <!-- <v-select v-model="payment_method"
                                            :options="allPaymentMethods"
                                            label="display_name"
                                            autocomplete="false"
                                            class="existing-contact" style="width:100%;margin:0 auto;"
                                            @selected="setPaymentMethod"></v-select> -->
                            </div>
                        </div>

                    </fieldset>

                    <fieldset :class="{isTpg:isTpg}">
                        <div class="section-header">
                            IT Information
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                IT Contact:
                            </div>
                            <div class="col-lg-7">
                                <vue-select close-on-select v-model="it_contact" :placeholder="it_contact.display_name" :options="accountContacts" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setITContact" v-if="accountContacts && accountContacts.length > 0">
                                </vue-select>

                                <div class="add-contact-container" v-else @click="popContactsModal('add',IT_CONTACT_CATEGORY_ID)">Add a contact to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountContacts && accountContacts.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popContactsModal('manage',IT_CONTACT_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popContactsModal('add',IT_CONTACT_CATEGORY_ID)">+ Add Contact</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popContactsModal('add',IT_CONTACT_CATEGORY_ID)">

                            </div>
                        </div>

                    </fieldset>

                    <fieldset :class="{isTpg:isTpg}">
                        <div class="section-header">
                            Music Direction
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :class="{isTpg:isTpg}">
                                Music Contact:
                            </div>
                            <div class="col-lg-7">
                                <vue-select close-on-select v-model="music_contact" :placeholder="music_contact.display_name" :options="accountContacts" label-by="display_name" autocomplete="false" class="existing-contact" style="width:100%;margin:0 auto;" @selected="setMusicContact" v-if="accountContacts && accountContacts.length > 0">
                                </vue-select>

                                <div class="add-contact-container" v-else @click="popContactsModal('add',MUSIC_CONTACT_CATEGORY_ID)">Add a contact to your account by clicking here</div>
                                <div class="modalPopLink" v-if="accountContacts && accountContacts.length > 0" :class="{isTpg:isTpg}">
                                    <!-- <span @click="popContactsModal('manage',MUSIC_CONTACT_CATEGORY_ID)">Manage</span> -->
                                    <span @click="popContactsModal('add',MUSIC_CONTACT_CATEGORY_ID)">+ Add Contact</span>
                                </div>
                            </div>
                            <div class="col-lg-1 add-contact-bitton" @click="popContactsModal('add',MUSIC_CONTACT_CATEGORY_ID)">

                            </div>
                        </div>

                    </fieldset>

                    <fieldset :class="{isTpg:isTpg}" id="zoneContainer">
                        <div class="section-header">
                            Zone Management
                        </div>

                        <!-- <div class="alert alert-secondary" role="alert" v-if="zoneUpdated" style="margin-bottom: 20px;margin-top:40px;">
                                {{zoneUpdateMessage}}
                            </div> -->

                        <div v-if="location_zones && location_zones.length > 0">
                            <div class="row zone-row border-bottom" :class="{isTpg:isTpg}" v-for="(zone, itemObjKey) in location_zones" :key="itemObjKey" @click="popLocationZoneForm(zone)">
                                <div class="col-lg-7" style="white-space: nowrap; overflow: hidden;text-overflow: ellipsis;">
                                    <span>{{itemObjKey + 1}}</span>. <span class="zone-link">{{zone.name}} <span v-if="zone.demo_signup_status_id">  (<i>{{zoneStatus(zone)}}</i>)</span></span>
                                </div>
                                <div class="col-lg-4">
                                    <span v-if="zone.msa && zone.msa.client_document_type_id == UNSIGNED_MSA_ID && !shouldHideSignature" style="font-weight: bold;padding-left:20px;">[Signature needed]</span>
                                    <span v-if="zone.msa && zone.msa.client_document_type_id == SIGNED_MSA_ID && !shouldHideSignature" style="padding-left:20px;">[Signed]</span>
                                </div>
                                <div class="col-lg-1">
                                    <span class="zone-link">Edit</span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="row zone-row">
                            You do not have any zones for this location yet, click below to create one.
                        </div>
                        <div class="row zone-row" :class="{isTpg:isTpg}" style="visibility: hidden; display: none;">
                            <div class="col-lg-8">
                                <span @click="popLocationZoneForm(null)" class="zone-link"><b>Add New Zone</b></span>
                            </div>
                            <div class="col-lg-4"></div>
                        </div>

                    </fieldset>
                </div>
                <div style="width:100%;text-align: center;margin-top:20px;margin-bottom:20px;padding-bottom:20px;">
                    <button class="clean-grayv" type="submit" style="width:300px;" :disabled="formHasBeenSubmitted">
                            <span v-if="formHasBeenSubmitted">Working ..</span>
                            <span v-else>Submit</span>
                        </button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vue3-datepicker';
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import AddAddressModal from '../../shared/AddAddressModal.vue';
import AddContactModal from '../../shared/AddContactModal.vue';
import LocationZone from './LocationZone.vue';
import PaymentMethodModal from '../../shared/PaymentMethodModal.vue';

const Querystring = require('querystring');

const ZoneStatuses = {
  DEFAULT: 0,
  DEMO: 12,
  DEMO_EMAIL_SENT: 13,
  SKIP_DEMO: 14,
  EXISTING_NEW: 15,
};

export default {
  props: ['states', 'regions', 'account-info', 'is-tpg'],
  inject: ['cwGlobal'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      showReload: false,
      showReloadMessage: '',
      formHasBeenSubmitted: false,
      userInfo: '',
      id: '',
      account_id: '',
      name: '',
      already_open: false,
      startup_date: null,
      business_type: null,
      category_id: '',
      store_number: '',
      payment_method: null,
      general_manager: { id: '', display_name: 'Select Contact' },
      shipping_contact: { id: '', display_name: 'Select Contact' },
      billing_contact: { id: '', display_name: 'Select Contact' },
      music_contact: { id: '', display_name: 'Select Contact' },
      it_contact: { id: '', display_name: 'Select Contact' },
      physical_address: { id: '', display_name: 'Select Address' },
      billing_address: { id: '', display_name: 'Select Address' },
      shipping_address: { id: '', display_name: 'Select Address' },
      contactModalCategoryId: '',
      addressModalCategoryId: '',
      location_zones: [],
      documents: [],
      payment_info: {},
      allPaymentMethods: [],
      errorString: '',
      accountContacts: [{ id: '0', display_name: '' }],
      accountAddresses: [],
      shouldShowPaymentMethod: true,
      categories: [],
      locationStatus: ZoneStatuses.DEFAULT,
      zoneUpdated: false,
      messageTimer: '',
      zoneUpdateMessage: '',
      shouldHideSignature: false,
      ACCOUNTING_SERVICE_OPTION_ID: 28,
      BILLING_CONTACT_CATEGORY_ID: 14,
      GM_CONTACT_CATEGORY_ID: 15,
      SHIPPING_CONTACT_CATEGORY_ID: 107,
      IT_CONTACT_CATEGORY_ID: 100,
      MUSIC_CONTACT_CATEGORY_ID: 101,
      BILLING_ADDRESS_CATEGORY_ID: 20,
      PHYSICAL_ADDRESS_CATEGORY_ID: 24,
      SHIPPING_ADDRESS_CATEGORY_ID: 83,
      UNSIGNED_MSA_ID: 12,
      SIGNED_MSA_ID: 13,
      HIDE_MSA_SERVICE_OPTION_ID: 30,
      showPaymentModal: false,
      showAddressModal: false,
      showContactModal: false,
      showZoneModal: false,
      selectedLocationZoneId: null,
    };
  },
  validations() {
    return {
      name: { required: helpers.withMessage('Location name is required', required) },
    };
  },
  mounted() {
    if (this.$route && this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    this.getUserInfo();
    this.getCategories();

    // $(this.$refs.modalContacts).on("hidden.bs.modal", this.doSometing)
  },
  methods: {
    setGMContact(value) {
      if (value && value.id) {
        this.deleteContactAssociation(this.general_manager, this.GM_CONTACT_CATEGORY_ID);
        this.createContactAssociation(value, this.GM_CONTACT_CATEGORY_ID);
        this.general_manager = value;
      } else {
        this.deleteContactAssociation(this.general_manager, this.GM_CONTACT_CATEGORY_ID);
        this.general_manager = null;
      }
    },
    setShippingContact(value) {
      if (value && value.id) {
        this.deleteContactAssociation(this.shipping_contact, this.SHIPPING_CONTACT_CATEGORY_ID);
        this.createContactAssociation(value, this.SHIPPING_CONTACT_CATEGORY_ID);
        this.shipping_contact = value;
      } else {
        this.deleteContactAssociation(this.shipping_contact, this.SHIPPING_CONTACT_CATEGORY_ID);
        this.shipping_contact = null;
      }
    },
    setBillingContact(value) {
      if (value && value.id) {
        this.deleteContactAssociation(this.billing_contact, this.BILLING_CONTACT_CATEGORY_ID);
        this.createContactAssociation(value, this.BILLING_CONTACT_CATEGORY_ID);
        this.billing_contact = value;
      } else {
        this.deleteContactAssociation(this.billing_contact, this.BILLING_CONTACT_CATEGORY_ID);
        this.billing_contact = null;
      }
    },
    setITContact(value) {
      if (value && value.id) {
        this.deleteContactAssociation(this.it_contact, this.IT_CONTACT_CATEGORY_ID);
        this.createContactAssociation(value, this.IT_CONTACT_CATEGORY_ID);
        this.it_contact = value;
      } else {
        this.deleteContactAssociation(this.it_contact, this.IT_CONTACT_CATEGORY_ID);
        this.it_contact = null;
      }
    },
    setMusicContact(value) {
      if (value && value.id) {
        this.deleteContactAssociation(this.music_contact, this.MUSIC_CONTACT_CATEGORY_ID);
        this.createContactAssociation(value, this.MUSIC_CONTACT_CATEGORY_ID);
        this.music_contact = value;
      } else {
        this.deleteContactAssociation(this.music_contact, this.MUSIC_CONTACT_CATEGORY_ID);
        this.music_contact = null;
      }
    },
    createContactAssociation(contact, category_id) {
      this.errorString = '';
      let contactParams = {
        'category_ids[]': category_id,
        'relations[0][type]': 'Location',
        'relations[0][id]': this.id,
        is_primary: 1,
      };
      contactParams = Querystring.stringify(contactParams);

      const self = this;
      this.$http.put(`/v2/contact/${contact.id}`, contactParams).then((response) => {
        if (response.error == true) {
          let responseErrors = '';
          if (response) {
            responseErrors = self.returnFriendlyErrors(response);
          }
          try {
            self.$wkToast(`1${responseErrors}`);
          } catch (error) { console.log(''); }
        }
      },
      (response) => {
        let responseErrors = '';
        if (response) {
          responseErrors = self.returnFriendlyErrors(response);
        }

        self.$wkToast(`2${responseErrors}`);
      }).catch((response) => {
        let responseErrors = '';
        if (response) {
          responseErrors = self.returnFriendlyErrors(response);
        }
        self.$wkToast(`3a${responseErrors}`);
      });
    },
    returnFriendlyErrors(response) {
      if (!response) return;

      if (response && response.data && (response.error == 'Unauthenticated.' || response.data.error == 'Unauthenticated')) {
        window.location.reload();
      }

      let errorString = '';
      if (response) {
        if (response.data) {
          errorString += this.parseDataKeys(response.data.fields);
        }
        if (response.message) {
          errorString += response.message;
        }
      }

      return errorString;
    },
    deleteContactAssociation(contact, category_id) {
      this.errorString = '';
      if (!contact || !contact.id || contact.id == '' || !category_id) { return; }
      const self = this;
      this.$http.delete(`/v2/category/${category_id}/contact/${contact.id}`).then((response) => {
        if (response.data.error == true) {
          let responseErrors = '';
          if (response) {
            responseErrors = self.returnFriendlyErrors(response);
          }
          self.errorString = `1: ${responseErrors}`;
          self.$wkToast(self.errorString);
        }
      },
      function (response) {
        let responseErrors = '';
        if (response) {
          responseErrors = self.returnFriendlyErrors(response);
        }
        self.errorString = `2: ${responseErrors}`;
        self.$wkToast(this.errorString);
      }).catch(() => {
        this.errorString = '3b: Oops, there was a network issue. Please try again';
      });
    },
    setPhysicalAddress(value) {
      if (value && value.id) {
        this.deleteAddressAssociation(this.physical_address, this.PHYSICAL_ADDRESS_CATEGORY_ID);
        this.createAddressAssociation(value, this.PHYSICAL_ADDRESS_CATEGORY_ID);
        this.physical_address = value;
      } else {
        this.deleteAddressAssociation(this.physical_address, this.PHYSICAL_ADDRESS_CATEGORY_ID);
        this.physical_address = null;
      }
    },
    setBillingAddress(value) {
      if (value && value.id) {
        this.deleteAddressAssociation(this.billing_address, this.BILLING_ADDRESS_CATEGORY_ID);
        this.createAddressAssociation(value, this.BILLING_ADDRESS_CATEGORY_ID);
        this.billing_address = value;
      } else {
        this.deleteAddressAssociation(this.billing_address, this.BILLING_ADDRESS_CATEGORY_ID);
        this.billing_address = null;
      }
    },
    setShippingAddress(value) {
      if (value && value.id) {
        this.deleteAddressAssociation(this.shipping_address, this.SHIPPING_ADDRESS_CATEGORY_ID);
        this.createAddressAssociation(value, this.SHIPPING_ADDRESS_CATEGORY_ID);
        this.shipping_address = value;
      } else {
        this.deleteAddressAssociation(this.shipping_address, this.SHIPPING_ADDRESS_CATEGORY_ID);
        this.shipping_address = null;
      }
    },
    createAddressAssociation(address, category_id) {
      this.errorString = '';
      let adressParams = {
        'category_ids[]': category_id,
        'relations[0][type]': 'Location',
        'relations[0][id]': this.id,
        is_primary: 1,
      };
      adressParams = Querystring.stringify(adressParams);

      const self = this;
      this.$http.put(`/v2/address/${address.id}`, adressParams).then((response) => {
        if (response.error == true) {
          let responseErrors = '';
          if (response) {
            responseErrors = self.returnFriendlyErrors(response);
          }
          self.errorString = `1: ${responseErrors}`;
          self.$wkToast(self.errorString);
        }
      },
      (response) => {
        let responseErrors = '';
        if (response) {
          responseErrors = self.returnFriendlyErrors(response);
        }
        self.errorString = `2: ${responseErrors}`;
        self.$wkToast(self.errorString);
      });
    },
    deleteAddressAssociation(address, category_id) {
      this.errorString = '';
      if (!address || !address.id || address.id == '' || !category_id) { return; }
      const self = this;
      this.$http.delete(`/v2/category/${category_id}/address/${address.id}`).then((response) => {
        if (response.data.error == true) {
          let responseErrors = '';
          if (response) {
            responseErrors = self.returnFriendlyErrors(response);
          }
          self.errorString = `1: ${responseErrors}`;
          try {
            self.$wkToast(self.errorString);
          } catch (error) { console.log(''); }
        }
      },
      (response) => {
        let responseErrors = '';
        if (response) {
          responseErrors = self.returnFriendlyErrors(response);
        }
        self.errorString = `2: ${responseErrors}`;
        try {
          self.$wkToast(self.errorString);
        } catch (error) { console.log(''); }
      });
    },
    getCategories() {
      // const json = require('json-loader!../../cw.json');
      // let all_categories = json.categories;
      const json = this.cwGlobal;
      const all_categories = json.categories;
      // Only allow category type id = 2
      for (let i = 0; i < all_categories.length; i++) {
        if (all_categories[i].category_type_id == 2) {
          this.categories.push(all_categories[i]);
        }
      }

      this.categories = sortByKey(this.categories, 'name');
      this.categories.unshift({ id: '0', name: '' });
      // Get specified location
      this.getLocation();
    },
    getUserInfo() {
      const self = this;
      this.$http.get('/user').then((response) => {
        self.userInfo = response.data;
      },
      () => {
        self.showReload = true;
        self.showReloadMessage = '1. Error getting user info.';

        try {
          self.$wkToast('2. Error getting user info.');
        } catch (error) { console.log(''); }
      }).catch(() => {
        self.showReload = true;
        self.showReloadMessage = '2. Error getting user info.';
        // this.$toasted.show("2. Error getting user info.", TOAST_RELOAD);
      });
    },
    submitForm() {
      this.formHasBeenSubmitted = true;
      this.v$.$validate();
      this.errorString = '';
      if (this.v$.$error) {
        this.formHasBeenSubmitted = false;
        const errors = this.v$.$errors;
        let errorList = '<b>Errors</b><ul>';
        for (let i = 0; i < errors.length; i++) {
          errorList += `<li>${errors[i].$message}</li>`;
        }

        errorList += '</ul>';
        this.$wkToast(errorList);
        return;
      }

      const location = {
        account_id: this.account_id,
      };
      if (this.name) {
        location.name = this.name;
      }
      if (this.already_open) {
        location.already_open = 1;
      } else {
        location.already_open = 0;
      }
      if (this.startup_date) {
        location.startup_date = this.formatDate(this.startup_date);
      }
      if (this.store_number) {
        location.store_number = this.store_number;
      }
      if (this.business_type && this.business_type.id) {
        location.category_id = this.business_type.id;
      }

      const self = this;

      const locationQueryString = Querystring.stringify(location);
      this.$http.put(`/v2/location/${this.id}`, locationQueryString).then((response) => {
        if (response.data.error == true) {
          self.formHasBeenSubmitted = false;
          const responseErrors = self.returnFriendlyErrors(response);
          self.errorString = `1: ${responseErrors}`;
          try {
            self.$wkToast(self.errorString);
          } catch (error) { `/v2/location/ ${error}`; }
        } else {
          self.errorString = '';
          self.$router.push({ name: 'location-updated' });
        }
      },
      () => {
        self.formHasBeenSubmitted = false;
        self.errorString = '2: There was an error saving the form; please try again.';
        try {
          self.$wkToast(self.errorString);
        } catch (error) { console.log(`/v2/location/ ${error}`); }
      }).catch(() => {
        self.formHasBeenSubmitted = false;
        self.errorString = '3: There was an error saving the form; please try again.';
      });
    },
    newPaymentMethodCreated(paymentMethod) {
      paymentMethod.payment_type_id = paymentMethod.id;
      this.allPaymentMethods.push(paymentMethod);
      this.payment_method = paymentMethod;
    },
    getLocation() {
      if (this.$route && this.$route.params.id) {
        const self = this;
        this.$http.get(`/v2/location/${this.id}`).then((response) => {
          const { location } = response.data.data;
          self.setLocationModel(location);

          // Get Zones
          self.getLocationZones();
        },
        function (response) {
          // Check for authorization error
          if (response && response.data && response.data.data && response.data.data.fields) {
            for (const key in response.data.data.fields) {
              // if field get is location_id, direct to main locations view
              if (key == 'location_id') {
                window.location.href = '/#/locations';
                return;
              }
            }

            self.errorString = 'There was an error fetching location informtion.';
            try {
              self.$wkToast(self.errorString);
            } catch (error) { console.log(`/v2/location/ ${error}`); }
          } else {
            self.errorString = 'There was an error fetching location informtion.';
            try {
              self.$wkToast(this.errorString);
            } catch (error) { console.log(`/v2/location/ ${error}`); }
          }
        }).catch(() => {
          self.errorString = `Problem loading location ${self.id}`;
          // this.$toasted.show( this.errorString, TOAST_ERROR);
        });
      }
    },
    getLocationZones() {
      const self = this;
      this.$http.get('/v2/zone').then((response) => {
        if (!response.data.data.zones) { return; }
        const { zones } = response.data.data;
        for (let i = 0; i < zones.length; i++) {
          zones[i].msa = null;
          zones[i].has_unsigned_msa = false;
          const locId = zones[i].location_id;

          if (locId == self.id) {
            self.location_zones.push(zones[i]);
          }
        }
        self.location_zones = sortByKey(self.location_zones, 'name');

        self.checkForDemoSignup();
        self.getAllPaymentMethods();
        self.getDocs();
      },
      () => {
        self.errorString = 'Error getting zones';
        try {
          self.$wkToast(self.errorString);
        } catch (error) { console.log(`/v2/location/ ${error}`); }
      }).catch(() => {
        self.errorString = 'Error getting zones';
        // this.$toasted.show( this.errorString, TOAST_ERROR);
      });
    },
    checkForDemoSignup() {
      if (!this.location_zones) return;
      // Check for demo signup
      let locationHasOnboarding = false;
      if (this.userInfo && this.userInfo.demo_signup_zones) {
        const { demo_signup_zones } = this.userInfo;
        for (const demo_signup_zone in demo_signup_zones) {
          if (Object.prototype.hasOwnProperty.call(demo_signup_zones, demo_signup_zone)) {
            const demo_status = demo_signup_zones[demo_signup_zone][0];
            for (let i = 0; i < this.location_zones.length; i++) {
              if (demo_status.location_zone_id == this.location_zones[i].id) {
                this.location_zones[i].demo_signup_status_id = demo_status.demo_signup_status_id;

                if (demo_status.demo_signup_status_id == ZoneStatuses.DEMO && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.DEMO;
                  locationHasOnboarding = true;
                } else if (demo_status.demo_signup_status_id == ZoneStatuses.DEMO_EMAIL_SENT && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.DEMO_EMAIL_SENT;
                  locationHasOnboarding = true;
                } else if (demo_status.demo_signup_status_id == ZoneStatuses.SKIP_DEMO && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.SKIP_DEMO;
                  locationHasOnboarding = true;
                } else if (demo_status.demo_signup_status_id == ZoneStatuses.EXISTING_NEW && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.EXISTING_NEW;
                  locationHasOnboarding = true;
                }
              }
            }
          }
        }
      }
      // We have location id.
      // console.log("this location id " + this.id);

      // //Need to get all zones for this location. We have zones.
      // for (const location_zone in this.location_zones) {
      //     if (location_zones.hasOwnProperty(location_zone)) {
      //         const zid = location_zone;
      //         console.log("zone " + location_zone);

      //         let locations = accounts[account].locations;

      //     }

      // }
      // We need to check each zone in user if it has status == 12|13
    },
    getDocs() {
      this.documents = [];
      if (!this.id) {
        this.showReload = true;
        this.showReloadMessage = 'Unable to load documents.';
      }
      const self = this;
      this.$http.get(`/v2/document/location/${this.id}?include_associated=1&include_zones=1`).then((response) => {
        self.documents = response.data.data.location.zone;
        self.setZoneDocs();
      },
      () => {
        self.errorString = 'Error getting documents';
        try {
          self.$wkToast(self.errorString);
        } catch (error) { console.log(''); }
      }).catch(() => {
        self.errorString = 'Error getting documents';
        // this.$toasted.show( this.errorString, TOAST_ERROR);
      });
    },
    setZoneDocs() {
      if (!this.documents) return;
      for (let i = 0; i < this.location_zones.length; i++) {
        this.location_zones[i].has_unsigned_msa = false;
        const lzid = this.location_zones[i].id;
        let firstZoneMsaFound = false;
        if (this.documents[lzid]) {
          let zoneDocs = this.documents[lzid];
          if (zoneDocs) {
            zoneDocs = sortByKey(zoneDocs, 'upload_date').reverse();
            for (let j = 0; j < zoneDocs.length; j++) {
              if (firstZoneMsaFound == false) {
                if (zoneDocs[j].client_document_type_id == this.UNSIGNED_MSA_ID || zoneDocs[j].client_document_type_id == this.SIGNED_MSA_ID) {
                  firstZoneMsaFound = true;
                  this.location_zones[i].msa = zoneDocs[j];
                  if (zoneDocs[j].client_document_type_id == this.UNSIGNED_MSA_ID) {
                    this.location_zones[i].has_unsigned_msa = true;
                  }
                  if (zoneDocs[j].client_document_type_id == this.SIGNED_MSA_ID) {
                    this.location_zones[i].has_unsigned_msa = true;
                  }
                }
              }
            }
          }
        }
      }
    },
    setLocationPayment() {
      if (!this.allPaymentMethods) {
        return;
      }

      // Todo.  Match up with
      for (let i = 0; i < this.allPaymentMethods.length; i++) {
        if (this.id == this.allPaymentMethods[i].f_id) {
          this.getLocationPaymentMethod(this.allPaymentMethods[i].payment_id);
          return;
        }
      }

      // this.getLocationPaymentMethod();
    },
    getLocationPaymentMethod(id) {
      const self = this;
      this.$http.get(`/payment/${id}`).then((response) => {
        self.payment_method = response.data.data.forte;
      },
      () => {
        self.errorString = 'Error getting payment methods';
        self.$wkToast(self.errorString);
      }).catch((response) => {
        if (response) console.log(response);
      });
    },
    getAllPaymentMethods() {
      const self = this;
      this.$http.get('/payment?include_associated=1').then((response) => {
        self.allPaymentMethods = [];

        const paymentCount = response.data.length;

        for (let i = 0; i < paymentCount; i++) {
          const payment = response.data[i];
          let paymentType = 'CC';
          if (payment.payment_type_id == '2') {
            paymentType = 'ACH';
          }
          payment.display_name = `${paymentType} ${payment.name_on_account}`;
          self.allPaymentMethods.push(payment);
        }

        self.setLocationPayment();
      },
      () => {
        self.errorString = 'Error getting payments';
        self.$wkToast(self.errorString);
      }).catch((response) => {
        if (response) console.log(response);
      });
    },
    popPaymentsModal() {
      // Display modal
      // this.$refs.modalPaymentMethod.show();
      this.showPaymentModal = true;
    },
    popLocationZoneForm(selected_zone) {
      let zid = null;
      if (selected_zone) {
        zid = selected_zone.id;
      }
      this.selectedLocationZoneId = zid;
      this.showZoneModal = true;
    },
    setLocationModel(location) {
      this.name = location.name;
      this.account_id = location.account_id;
      this.store_number = location.store_number;
      if (location.already_open == 1) {
        this.already_open = true;
      } else {
        this.already_open = false;
      }
      // this.category_id = location.category_id;
      if (location.startup_date) {
        this.startup_date = new Date(`${location.startup_date}T16:00:00.000Z`);
      }

      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id == location.category_id) {
          this.business_type = this.categories[i];
        }
      }
    },
    removeContactFromObject(contact) {
      // Use email to get index for removal
      const removeIndex = this.accountContacts.map((item) => item.email).indexOf(contact.email);
      this.accountContacts.splice(removeIndex, 1);

      // If deleted contact is set as an active contact, remove it.
      if (this.shipping_contact && (contact.id == this.shipping_contact.id)) {
        this.shipping_contact = null;
      } else if (this.billing_contact && (contact.id == this.billing_contact.id)) {
        this.billing_contact = null;
      } else if (this.music_contact && (contact.id == this.music_contact.id)) {
        this.music_contact = null;
      } else if (this.it_contact && (contact.id == this.it_contact.id)) {
        this.it_contact = null;
      } else if (this.general_manager && (contact.id == this.general_manager.id)) {
        this.general_manager = null;
      }
    },
    removeAddressFromObject(address) {
      // Use id to get index for removal
      const removeIndex = this.accountAddresses.map((item) => item.id).indexOf(address.id);
      this.accountAddresses.splice(removeIndex, 1);

      // If deleted address is set as an active address, remove it.
      if (this.physical_address && (address.id == this.physical_address.id)) {
        this.physical_address = null;
      } else if (this.billing_address && (address.id == this.billing_address.id)) {
        this.billing_address = null;
      } else if (this.shipping_address && (address.id == this.shipping_address.id)) {
        this.shipping_address = null;
      }
    },
    zoneSaved(zone) {
      const updateIndex = this.location_zones.map((item) => item.id).indexOf(zone.id);
      this.location_zones[updateIndex] = zone;
      this.location_zones = sortByKey(this.location_zones, 'name');

      // this.zoneUpdated = true;
      this.zoneUpdateMessage = 'Zone saved successfully';
      try {
        this.$wkToast(this.zoneUpdateMessage);
      } catch (error) { console.log(''); }

      // this.messageTimer = setInterval(this.removeZoneUpdatedMessage, 5000)

      this.getDocs();
    },
    zoneCreated(zone) {
      if (!zone || !zone.id) {
        this.location_zones = [];
        this.getLocationZones();
      } else {
        this.location_zones.push(zone);
        this.location_zones = sortByKey(this.location_zones, 'name');
      }

      this.zoneUpdated = true;
      this.zoneUpdateMessage = `Zone (${zone.name}) created successfully`;

      this.messageTimer = setInterval(this.removeZoneUpdatedMessage, 5000);
    },
    removeZoneUpdatedMessage() {
      this.zoneUpdated = false;
      clearInterval(this.messageTimer);
    },
    setAccountId() {
      if (this.userInfo && this.userInfo.accounts) {
        this.account_id = this.userInfo.accounts[0];
      }
    },
    addContact(contact) {
      const new_contact = contact;
      new_contact.display_name = `${contact.first_name} ${contact.last_name}`;
      this.accountContacts.push(new_contact);

      if (contact.category_id === this.GM_CONTACT_CATEGORY_ID) {
        this.general_manager = contact;
        this.createContactAssociation(contact, this.GM_CONTACT_CATEGORY_ID);
      } else if (contact.category_id === this.IT_CONTACT_CATEGORY_ID) {
        this.it_contact = contact;
        this.createContactAssociation(contact, this.IT_CONTACT_CATEGORY_ID);
      } else if (contact.category_id === this.MUSIC_CONTACT_CATEGORY_ID) {
        this.music_contact = contact;
        this.createContactAssociation(contact, this.MUSIC_CONTACT_CATEGORY_ID);
      } else if (contact.category_id === this.SHIPPING_CONTACT_CATEGORY_ID) {
        this.shipping_contact = contact;
        this.createContactAssociation(contact, this.SHIPPING_CONTACT_CATEGORY_ID);
      } else if (contact.category_id === this.BILLING_CONTACT_CATEGORY_ID) {
        this.billing_contact = contact;
        this.createContactAssociation(contact, this.BILLING_CONTACT_CATEGORY_ID);
      }
    },
    addAddress(address) {
      const new_address = address;

      this.accountAddresses.push(new_address);

      if (new_address.category_id === this.PHYSICAL_ADDRESS_CATEGORY_ID) {
        this.physical_address = new_address;
        this.createAddressAssociation(address, this.PHYSICAL_ADDRESS_CATEGORY_ID);
      } else if (new_address.category_id === this.SHIPPING_ADDRESS_CATEGORY_ID) {
        this.shipping_address = new_address;
        this.createAddressAssociation(address, this.SHIPPING_ADDRESS_CATEGORY_ID);
      } else if (new_address.category_id === this.BILLING_ADDRESS_CATEGORY_ID) {
        this.billing_address = new_address;
        this.createAddressAssociation(address, this.BILLING_ADDRESS_CATEGORY_ID);
      }
    },
    popAddressesModal(action, category_id) {
      this.addressModalCategoryId = category_id;
      if (action === 'manage') {
        // this.$refs.modalManageAddresses.show();
      } else {
        this.showAddressModal = true;
        // this.$refs.modalAddAddresses.show();
      }
    },
    popContactsModal(action, category_id) {
      this.contactModalCategoryId = category_id;
      if (action === 'manage') {
        // this.$refs.modalManageContacts.show();
      } else {
        this.showContactModal = true;
        // this.$refs.modalContacts.show();
      }
    },
    pad(n) { return n < 10 ? `0${n}` : n; },
    getAccountContacts() {
      const self = this;
      this.$http.get('/v2/contact?include_associated=1&group_by=category').then((response) => {
        self.populateContactsFromResponse(response.data);
      },
      () => {
        self.errorString = 'Error getting account contacts';
        // this.$toasted.show( this.errorString, TOAST_ERROR);
      }).catch((response) => {
        if (response) console.log(response);
      });
    },
    getAccountAddresses() {
      const self = this;
      this.$http.get('/v2/address?include_associated=1&group_by=category')
        .then((response) => {
          self.populateAddressesFromResponse(response.data);
        }, () => {
          self.errorString = 'Error getting account addresses';
          // this.$toasted.show(this.errorString);
        })
        .catch((response) => {
          if (response) console.log(response);
        });
    },
    populateContactsFromResponse(response_body) {
      const { accounts } = response_body.data;
      const tempContacts = [];
      // this.accountContacts.unshift({"id":"ADD","display_name":'+ Add Contact', 'class':'add-new-contact'});
      // this.accountContacts.unshift({"id":"","display_name":"","class":""})
      for (const account in accounts) {
        if (Object.prototype.hasOwnProperty.call(accounts, account)) {
          const { locations } = accounts[account];

          for (const location in locations) {
            if (Object.prototype.hasOwnProperty.call(locations, location)) {
              const { contacts } = locations[location];

              for (const contact in contacts) {
                if (Object.prototype.hasOwnProperty.call(contacts, contact)) {
                  const new_contact = contacts[contact];
                  if (new_contact.email) {
                    const displayName = `${new_contact.first_name} ${new_contact.last_name}`;
                    new_contact.display_name = displayName.substr(0, 32);
                    new_contact.class = '';
                    tempContacts.push(new_contact);

                    if (location == this.id) {
                      this.checkContactForPrimaryCategory(new_contact);
                    }
                  }
                }
              }
            }
          }
        }
      }

      this.accountContacts = this.removeDuplicateContacts(tempContacts);
      this.accountContacts = sortByKey(this.accountContacts, 'email');
      // this.general_manager = this.accountContacts[0];
      // this.checkForMissingPrimaryContacts();
    },
    checkForMissingPrimaryContacts() {
      if (!this.general_manager) {
        this.setNonPrimaryContact(this.GM_CONTACT_CATEGORY_ID);
      }
      if (!this.shipping_contact) {
        this.setNonPrimaryContact(this.SHIPPING_CONTACT_CATEGORY_ID);
      }
      if (!this.billing_contact) {
        this.setNonPrimaryContact(this.BILLING_CONTACT_CATEGORY_ID);
      }
      if (!this.it_contact) {
        this.setNonPrimaryContact(this.IT_CONTACT_CATEGORY_ID);
      }
      if (!this.music_contact) {
        this.setNonPrimaryContact(this.MUSIC_CONTACT_CATEGORY_ID);
      }
    },
    // If no is_primary is set for a category, select a non-primary for that same category
    setNonPrimaryContact(category_id) {
      for (let i = 0; i < this.accountContacts.length; i++) {
        const { categories } = this.accountContacts[i];
        for (const category in categories) {
          if (Object.prototype.hasOwnProperty.call(categories, category)) {
            if (categories[category].id == category_id) {
              if (category_id == this.MUSIC_CONTACT_CATEGORY_ID) {
                this.music_contact = this.accountContacts[i];
                return;
              }
              if (category_id == this.IT_CONTACT_CATEGORY_ID) {
                this.it_contact = this.accountContacts[i];
                return;
              }
              if (category_id == this.GM_CONTACT_CATEGORY_ID) {
                this.general_manager = this.accountContacts[i];
                return;
              }
              if (category_id == this.BILLING_CONTACT_CATEGORY_ID) {
                this.billing_contact = this.accountContacts[i];
                return;
              }
              if (category_id == this.SHIPPING_CONTACT_CATEGORY_ID) {
                this.shipping_contact = this.accountContacts[i];
                return;
              }
            }
          }
        }
      }
    },
    removeDuplicateContacts(contacts) {
      const countAccountContacts = contacts.length;
      const filteredContacts = [];
      for (let i = 0; i < countAccountContacts; i++) {
        const accountContact = contacts[i];
        const countFilteredContacts = filteredContacts.length;
        let contactExist = false;
        for (let j = 0; j < countFilteredContacts; j++) {
          if (accountContact.id == filteredContacts[j].id) {
            contactExist = true;
          }
        }
        if (!contactExist) {
          filteredContacts.push(accountContact);
        }
      }

      return filteredContacts;
    },
    checkContactForPrimaryCategory(contact) {
      const { categories } = contact;
      for (const category in categories) {
        if (Object.prototype.hasOwnProperty.call(categories, category)) {
          // If primary, check which cat
          if (categories[category].is_primary == 1) {
            if (categories[category].id == this.GM_CONTACT_CATEGORY_ID) {
              //             this.$nextTick(function() {
              //     this.$set(this.general_manager, contact);
              // });

              // this.general_manager = Object.assign({}, this.general_manager, contact);
              this.general_manager = contact;
            } else if (categories[category].id == this.SHIPPING_CONTACT_CATEGORY_ID) {
              this.shipping_contact = contact;
            } else if (categories[category].id == this.BILLING_CONTACT_CATEGORY_ID) {
              this.billing_contact = contact;
            } else if (categories[category].id == this.IT_CONTACT_CATEGORY_ID) {
              this.it_contact = contact;
            } else if (categories[category].id == this.MUSIC_CONTACT_CATEGORY_ID) {
              this.music_contact = contact;
            }
          }
        }
      }
    },
    checkAddressForPrimaryCategory(address) {
      const { categories } = address;
      for (const category in categories) {
        if (Object.prototype.hasOwnProperty.call(categories, category)) {
          // If primary, check which cat
          if (categories[category].is_primary == 1) {
            if (categories[category].id == this.PHYSICAL_ADDRESS_CATEGORY_ID) {
              this.physical_address = address;
            } else if (categories[category].id == this.SHIPPING_ADDRESS_CATEGORY_ID) {
              this.shipping_address = address;
            } else if (categories[category].id == this.BILLING_ADDRESS_CATEGORY_ID) {
              this.billing_address = address;
            }
          }
        }
      }
    },
    accountContactExist(contact) {
      for (let i = 0; i < this.accountContacts.length; i++) {
        const accountContact = this.accountContacts[i];
        if (accountContact.id == contact.id) {
          return true;
        }
      }

      return false;
    },
    populateAddressesFromResponse(response_body) {
      if (!this.id) return;
      // this.accountAddresses = [];
      const { accounts } = response_body.data;
      // this.accountAddresses.unshift({"id":"ADD","display_name":'<div style="font-color:rgb(54, 54, 54);"><i class="fas fa-plus-circle"></i>  Add Address</div>','class':'add-new-contact'})
      // this.accountAddresses.unshift({"id":"","display_name":""})
      // Get all addresses for all accounts
      for (const account in accounts) {
        if (Object.prototype.hasOwnProperty.call(accounts, account)) {
          const account_addresses = accounts[account];
          for (let i = 0; i < account_addresses.length; i++) {
            const new_address = account_addresses[i];
            let stateString = '';
            let cityString = '';
            let addressString = '';

            if (new_address.state && new_address.state.abbreviation) {
              stateString = new_address.state.abbreviation;
            }
            if (new_address.city) {
              cityString = new_address.city;
            }
            if (new_address.address_1) {
              addressString = new_address.address_1.substring(0, 25);
            }
            const displayName = `${addressString}, ${cityString} ${stateString}`;
            new_address.display_name = displayName.substr(0, 32);
            this.accountAddresses.push(new_address);

            this.checkAddressForPrimaryCategory(new_address);
          }
        }
      }

      if (response_body.data && response_body.data.locations) {
        const { locations } = response_body.data;
        const location_addresses = locations[this.id];
        if (locations && locations[this.id]) {
          for (let i = 0; i < location_addresses.length; i++) {
            const new_address = location_addresses[i];
            let stateString = '';
            if (new_address.state && new_address.state.abbreviation) {
              stateString = new_address.state.abbreviation;
            }
            new_address.display_name = `${new_address.address_1.substring(0, 25)}, ${new_address.city} ${stateString}`;

            this.accountAddresses.push(new_address);

            this.checkAddressForPrimaryCategory(new_address);
          }
        }
      }

      this.accountAddresses = this.removeDuplicateAddresses(this.accountAddresses);
      this.accountAddresses = sortByKey(this.accountAddresses, 'address_1');
    },
    removeDuplicateAddresses(addresses) {
      const countAccountAddresses = addresses.length;
      const filteredAddresses = [];
      for (let i = 0; i < countAccountAddresses; i++) {
        const accountAddress = addresses[i];

        const countFilteredAddresses = filteredAddresses.length;
        let addressExist = false;
        for (let j = 0; j < countFilteredAddresses; j++) {
          if (accountAddress.id == filteredAddresses[j].id) {
            addressExist = true;
          }
        }
        if (!addressExist) {
          filteredAddresses.push(accountAddress);
        }
      }

      return filteredAddresses;
    },
    doesAddressExist(address) {
      for (let i = 0; i < this.accountAddresses.length; i++) {
        if (this.accountAddresses[i].id == address.id) {
          return true;
        }
      }

      return false;
    },
    formatDate(unformatted_date) {
      let formattedDate = new Date(unformatted_date);
      const dd = String(formattedDate.getDate()).padStart(2, '0');
      const mm = String(formattedDate.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = formattedDate.getFullYear();

      formattedDate = `${yyyy}-${mm}-${dd}`;

      return formattedDate;
    },
    zoneStatus(zone) {
      if (!zone) return;

      if (zone.demo_signup_status_id == ZoneStatuses.DEMO || zone.demo_signup_status_id == ZoneStatuses.DEMO_EMAIL_SENT) {
        return 'Demo';
      } if (zone.demo_signup_status_id == ZoneStatuses.SKIP_DEMO) {
        return 'Skip Demo';
      } if (zone.demo_signup_status_id == ZoneStatuses.EXISTING_NEW) {
        return 'New';
      }
    },
  },
  computed: {
    demoTitle() {
      if (this.zoneStatus == ZoneStatuses.DEMO) {
        return 'Demo';
      } if (this.zoneStatus == ZoneStatuses.SKIP_DEMO) {
        return 'Skip Demo';
      } if (this.zoneStatus == ZoneStatuses.EXISTING_NEW) {
        return 'New';
      }

      return 'New';
    },
    enableDdates() {
      const today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth();
      const yyyy = today.getFullYear();

      return new Date(yyyy, mm, dd);
      // return {
      //     to: new Date(yyyy, mm, dd)
      // };
    },
    breadcrumbTitle() {
      if (this.$route && this.$route.name === 'add-location') {
        return 'Add Location';
      }
      return 'Edit Location'; // this.location.name;
    },
    filteredMonths() {
      const allMonths = [
        { i: 1, id: '01', name: 'January' },
        { i: 2, id: '02', name: 'February' },
        { i: 3, id: '03', name: 'March' },
        { i: 4, id: '04', name: 'April' },
        { i: 5, id: '05', name: 'May' },
        { i: 6, id: '06', name: 'June' },
        { i: 7, id: '07', name: 'July' },
        { i: 8, id: '08', name: 'August' },
        { i: 9, id: '09', name: 'September' },
        { i: 10, id: '10', name: 'October' },
        { i: 11, id: '11', name: 'November' },
        { i: 12, id: '12', name: 'December' },
      ];

      return allMonths;
    },
    expYears() {
      const expYears = [];
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i < currentYear + 10; i++) {
        const y = { id: `${i}`, name: `${i}` };
        expYears.push(y);
      }
      return expYears;
    },
  },
  watch: {
    location_zones() {
      // Check for demo signup
      let locationHasOnboarding = false;
      if (this.userInfo && this.userInfo.demo_signup_zones) {
        const { demo_signup_zones } = this.userInfo;
        for (const demo_signup_zone in demo_signup_zones) {
          if (Object.prototype.hasOwnProperty.call(demo_signup_zones, demo_signup_zone)) {
            const demo_status = demo_signup_zones[demo_signup_zone][0];
            for (let i = 0; i < this.location_zones.length; i++) {
              if (demo_status.location_zone_id == this.location_zones[i].id) {
                this.location_zones[i].demo_signup_status_id = demo_status.demo_signup_status_id;

                if (demo_status.demo_signup_status_id == ZoneStatuses.DEMO && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.DEMO;
                  locationHasOnboarding = true;
                } else if (demo_status.demo_signup_status_id == ZoneStatuses.DEMO_EMAIL_SENT && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.DEMO_EMAIL_SENT;
                  locationHasOnboarding = true;
                } else if (demo_status.demo_signup_status_id == ZoneStatuses.SKIP_DEMO && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.SKIP_DEMO;
                  locationHasOnboarding = true;
                } else if (demo_status.demo_signup_status_id == ZoneStatuses.EXISTING_NEW && !locationHasOnboarding) {
                  this.locationStatus = ZoneStatuses.EXISTING_NEW;
                  locationHasOnboarding = true;
                }
              }
            }
          }
        }
      }
    },
    userInfo() {
      // Hide signature if selected service_option
      if (this.userInfo && this.userInfo.service_options) {
        for (let i = 0; i < this.userInfo.service_options.length; i++) {
          if (this.userInfo.service_options[i].service_option_id == this.HIDE_MSA_SERVICE_OPTION_ID) {
            this.shouldHideSignature = true;
          }
        }
      }

      this.getAccountContacts();
      this.getAccountAddresses();
      // this.setAccountId();

      if (this.userInfo && this.userInfo.service_options) {
        for (let i = 0; i < this.userInfo.service_options.length; i++) {
          if (this.userInfo.service_options[i].service_option_id == this.ACCOUNTING_SERVICE_OPTION_ID) {
            this.shouldShowPaymentMethod = true;
            break;
          }
        }
      }
    },
    errorString() {
      if (this.errorString == '' || this.errorString == null) {
        return;
      }
      const element = document.getElementById('formTopping');
      if (!element) return;
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
  components: {
    Datepicker,
    AddAddressModal,
    AddContactModal,
    LocationZone,
    PaymentMethodModal,
  },
};

function sortByKey(array, key) {
  return array.sort((a, b) => {
    const x = a[key];
    const y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}
</script>

<style scoped>
a,
a:visited {
    color: blue;
}

.zone-link {
    cursor: pointer;
}

.zone-link:hover {
    color: yellow;
}

.location-form-content {
    background-color: rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    margin-bottom: 100px;
    margin-top: -1px;
    padding-top: 20px;
}

.location-form-content.isTpg {
    background-color: #efefef;
    color: #3a3a3a;
    opacity: 1;
    border: 0px;
}

.location-form-content.isTpg a {
    color: red;
}

.onboarding-container {
    /*max-width:666px;*/
    width: 100%;
    margin: 0 auto;
    margin-bottom: 100px;
}

.onboarding-container a {
    color: white;
    text-decoration: underline;
}

.onboarding-container .day-name {
    text-align: left;
    padding-right: 5px;
    margin-top: 4px;
}

.onboarding-container .header {
    font-weight: bold;
    margin-bottom: 15px;
    margin-top: 25px;
}

.onboarding-container .row {
    margin-bottom: 10px;
}

.onboarding-container fieldset {
    border-color: #fff;
    border-width: 0px;
    border-style: solid;
    padding: 10px;
    margin: 0;
    margin-top: 35px;
    background-color: rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    padding: 20px;
}

.onboarding-container fieldset legend {
    text-align: center;
    margin-left: 30px;
    color: white;
    border: 0px;
    font-weight: bold;
    margin-bottom: -15px;
}

.onboarding-container.isTpg fieldset {
    background-color: transparent;
    border: 1px solid #ccc;
}

.onboarding-container input[type="text"] {
    border: 0px solid #ccc;
    background: #fff;
    color: #000;
    border-radius: 5px;
    width: 100%;
    height: 36px;
    font-weight: normal;
}

.onboarding-container textarea {
    border: 1px solid #ccc;
}

.modalPopLink {
    height: 15px;
    text-align: right;
    cursor: pointer;
    float: right;
    width: 100%;
}

.modalPopLink span {
    padding-left: 15px;
}

.modalPopLink span:hover {
    color: yellow;
}

.modalPopLink.isTpg span:hover {
    color: #00c996;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #393f61;
    ;
}

.zone-row {
    padding: 0px 0px;
    width: 100%;
    margin: 0 auto;
    cursor: pointer;
}

.zone-row.border-bottom {
    border-bottom: 1px solid #ccc;
}

.zone-row div {
    height: 26px;
    line-height: 16px;
}

.zone-row.border-bottom:last-child {
    border-bottom: 0px;
}

.zone-row:hover span {
    color: yellow
}

.zone-row.isTpg:hover span {
    color: #00c996
}

.zone-row span:hover {
    color: yellow;
}

.zone-row.isTpg span:hover {
    color: #00c996
}

.add-contact-container,
.add-address-container {
    padding-top: 5px;
    width: 100%;
    height: 32px;
    line-height: 22px;
    text-align: center;
    background: white;
    color: black;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #ccc;
    opacity: .8;
}

.update-payment-link {
    cursor: pointer;
}

.update-payment-link:hover {
    color: yellow;
}

.update-payment-link.isTpg span:hover {
    color: #00c996
}

.demo-blurb {
    padding: 0px 20px 10px 20px;
}

.demo_header {
    font-weight: bold;
    margin-bottom: 15px;
    margin-top: 25px;
}

.intro-blurb {
    width: 100%;
    margin: 0 auto;
}

.add-new-contact {
    color: rgb(54, 54, 54);
}

.section-header {
    font-size: 20px;
    width: 100%;
    font-weight: bold;
    text-align: center;
    margin: 0 auto;
    padding: 10px;
    margin-bottom: 20px;
}
.dashed-line {
    width: 96%;
    margin: 0 auto;
    border-top: 2px dashed #999;
    height: 1px;
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>
